<form [formGroup]="form" class="transparent">
  <input
    #input
    type="file"
    class="file-input"
    [accept]="photoFileTypes.join()"
    (change)="uploadFile($event.target.files[0])">
</form>
